import React, {Component} from 'react';
import {Filter, TextInput, SelectInput, AutocompleteArrayInput, SearchInput} from 'react-admin';
import i18next from 'i18next';
import {IirsaCountriesService} from '~/../config/services/iirsa_countries.service';
import {getEtapas} from '~services/EtapaService';
import {getSources, Source} from 'config/services/sources.service';
import {CatalogItem, getScopes, getTerms, getTerritories, getTypes} from 'config/services/catalogs.service';
import {ThemesService} from 'config/services/themes.service';

import NestedSelectInput from '../NestedSelectInput';

/** The filters of the Acciones list and of the Analíticas charts. */
class ProjectFilter extends Component<any> {
    state = {
        countries: [],
        themes: [],
        stages: [],
        sources: [] as Source[],
        territories: [] as CatalogItem[],
        scopes: [] as CatalogItem[],
        terms: [] as CatalogItem[],
        types: [] as CatalogItem[]
    };

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        const cs = new IirsaCountriesService();
        cs.get_la().then(r => {
            this.setState({countries: r.data});
        });

        const ts = new ThemesService();
        ts.get().then(r => {
            this.setState({themes: r.data});
        });

        getEtapas().then((r: any) => {
            if (r.ok && r.data) {
                this.setState({stages: r.data});
            }
        });

        getSources().then(r => {
            if (r.ok && r.data) {
                this.setState({sources: r.data});
            }
        });

        getTerritories().then(r => {
            if (r.ok && r.data) {
                this.setState({territories: r.data.page});
            }
        });

        getScopes().then(r => {
            if (r.ok && r.data) {
                this.setState({scopes: r.data});
            }
        });

        getTerms().then(r => {
            if (r.ok && r.data) {
                this.setState({terms: r.data});
            }
        });

        getTypes().then(r => {
            if (r.ok && r.data) {
                this.setState({types: r.data});
            }
        });
    }

    render() {
        // A territory's page already lists only its Acciones; Analíticas filters without a free-text search.
        const {inTerritory, hideSearch, ...props} = this.props;
        return (
            <Filter {...props}>
                {!hideSearch && <SearchInput source={'search'} alwaysOn variant={'outlined'}/>}
                <TextInput source="code" label={i18next.t('projects-iirsa:code') as string} variant={'outlined'}/>
                <TextInput source="name" label={i18next.t('projects-iirsa:name') as string} variant={'outlined'}/>

                <NestedSelectInput
                    label={i18next.t('projects-iirsa:theme')}
                    source="themes"
                    fstSource="theme"
                    sndSource="subtheme"
                    fstLabel={i18next.t('projects-iirsa:theme')}
                    sndLabel={i18next.t('projects-iirsa:subtheme')}
                    fstChoices={this.state.themes}
                    // eslint-disable-next-line react/jsx-no-bind
                    getSndChoices={fstValue => [{id: null, name: ''}, ...fstValue.subthemes]}
                    variant={'outlined'}
                />

                <SelectInput source="stage" choices={this.state.stages} label={i18next.t('projects-iirsa:stage') as string} variant={'outlined'}/>

                <SelectInput source="source" choices={this.state.sources} label={i18next.t('projects-iirsa:exportSource') as string} variant={'outlined'}/>

                <AutocompleteArrayInput
                    label={i18next.t('projects-iirsa:countries') as string}
                    source="countries"
                    choices={this.state.countries}
                    variant={'outlined'}
                />

                {!inTerritory && (
                    <SelectInput source="territory" choices={this.state.territories} label={i18next.t('projects-iirsa:territory') as string} variant={'outlined'}/>
                )}

                <SelectInput source="scope" choices={this.state.scopes} label={i18next.t('projects-iirsa:exportScope') as string} variant={'outlined'}/>

                <SelectInput source="term" choices={this.state.terms} label={i18next.t('projects-iirsa:exportTerm') as string} variant={'outlined'}/>

                <SelectInput source="type" choices={this.state.types} label={i18next.t('projects-iirsa:exportProjectType') as string} variant={'outlined'}/>
            </Filter>
        );
    }
}

export default ProjectFilter;
